<template>
  <div class="apply-sp">
    <div class="breadcrumb" style="background: #fff">申请特殊价格</div>
    <div class="third-title"><span> SKU组价格信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="平台号:">
          <el-autocomplete v-model="basicInfo.storeCode" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" clearable @clear='clear' :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <span v-if="specialPriceVo1.storeCode === ''">未选择平台</span>
          <span v-else>已选平台：{{ specialPriceVo1.storeName }}</span>
        </el-form-item>
        <el-form-item label="申请方式:">
          <el-radio-group v-model="specialPriceVo1.applyType" @input="radioChange">
            <el-radio label="APPLY_BASE">基础P申请</el-radio>
            <el-radio label="APPLY_DISCOUNT">整体折扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && $route.query.spuProperty !== 'NORMAL'">
          <div style="width: auto" v-if="specialPriceVo1.applyType === 'APPLY_BASE'">
            <el-table :data="basicInfo.skuList" border width="100%">
              <el-table-column min-width="100px" prop="skuName" label="SKU名称">
              </el-table-column>
              <el-table-column min-width="100px" label="基础P数">
                <template v-slot="scope">
                  <span>{{ scope.row.basePage }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="maxPage" min-width="100px" label="最大P数"></el-table-column>
              <el-table-column prop="baseStep" min-width="150px" label="一次增加P数"></el-table-column>
              <el-table-column prop="basePagePrice" min-width="150px" label="基础P平台价格"></el-table-column>
              <el-table-column prop="baseStepPrice" min-width="150px" label="增加一次平台价格"></el-table-column>
              <el-table-column min-width="200px" label="申请基础P数价格">
                <template slot-scope="scope">
                  <el-input @input="inputBasePageSpecialPrice(scope)" v-model="scope.row.applyPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="specialPriceVo1.applyType === 'APPLY_DISCOUNT'">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
              <el-table-column min-width="100px" label="基础P数">
                <template v-slot="scope">
                  <span>{{ scope.row.basePage }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="maxPage" min-width="100px" label="最大P数"></el-table-column>
              <el-table-column prop="baseStep" min-width="100px" label="一次增加P数"></el-table-column>
              <el-table-column prop="basePagePrice" min-width="100px" label="基础P平台价格"></el-table-column>
              <el-table-column prop="applyBasePrice" min-width="100px" label="申请基础P平台价格"></el-table-column>
              <el-table-column prop="baseStepPrice" min-width="100px" label="增加一次平台价格"></el-table-column>
              <el-table-column prop="applyOncePrice" min-width="100px" label="申请增加一次平台价格"></el-table-column>
              <el-table-column min-width="200px" label="申请折扣">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" @input="inputSpecialPrice(scope)" class="color-blue"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'true' && $route.query.spuProperty !== 'NORMAL'">
          <div style="width: 500px" v-show="specialPriceVo1.applyType === 'APPLY_BASE'">
            <el-table :data="basicInfo.skuList" border width="500px">
              <el-table-column prop="skuName" label="SKU组名称"></el-table-column>
              <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
              <el-table-column label="申请基础P数价格">
                <template slot-scope="scope">
                  <el-input style="width:100%" @input="inputBasePageSpecialPrice(scope)" v-model="scope.row.applyPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="width:700px" v-show="specialPriceVo1.applyType === 'APPLY_DISCOUNT'">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column prop="skuName" label="SKU组名称"></el-table-column>
              <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
              <el-table-column prop="applyBasePrice" label="申请基础P平台价格"></el-table-column>
              <el-table-column label="申请基础P数折扣">
                <template slot-scope="scope">
                  <el-input style="width:100%" @input="inputSpecialPrice(scope)" v-model="scope.row.discount"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && $route.query.spuProperty === 'NORMAL'">
          <div style="width: auto" v-if="specialPriceVo1.applyType === 'APPLY_BASE'">
            <el-table :data="basicInfo.skuList" border width="100%">
              <el-table-column min-width="100px" prop="skuName" label="SKU名称">
              </el-table-column>
              <el-table-column prop="basePagePrice" min-width="150px" label="基础价格"></el-table-column>
              <el-table-column min-width="200px" label="申请价格">
                <template slot-scope="scope">
                  <el-input @input="inputBasePageSpecialPrice(scope)" v-model="scope.row.applyPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="specialPriceVo1.applyType === 'APPLY_DISCOUNT'">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
              <el-table-column prop="basePagePrice" min-width="100px" label="基础价格"></el-table-column>
              <el-table-column prop="applyBasePrice" min-width="100px" label="申请基础价格"></el-table-column>
              <el-table-column min-width="200px" label="申请折扣">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" @input="inputSpecialPrice(scope)" class="color-blue"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'true' && $route.query.spuProperty == 'NORMAL'">
          <div style="width: 500px" v-show="specialPriceVo1.applyType === 'APPLY_BASE'">
            <el-table :data="basicInfo.skuList" border width="500px">
              <el-table-column prop="skuName" label="SKU组名称"></el-table-column>
              <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
              <el-table-column label="申请基础P数价格">
                <template slot-scope="scope">
                  <el-input style="width:100%" @input="inputBasePageSpecialPrice(scope)" v-model="scope.row.applyPrice"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="width:700px" v-show="specialPriceVo1.applyType === 'APPLY_DISCOUNT'">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column prop="skuName" label="SKU组名称"></el-table-column>
              <el-table-column prop="basePagePrice" label="基础P平台价格"></el-table-column>
              <el-table-column prop="applyBasePrice" label="申请基础P平台价格"></el-table-column>
              <el-table-column label="申请基础P数折扣">
                <template slot-scope="scope">
                  <el-input style="width:100%" @input="inputSpecialPrice(scope)" v-model="scope.row.discount"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button @click="applySpecialStore" round type="primary">申请特殊价格</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { skuGroupDetail, skuSpecialAdd } from '@/api/pms'
import { storeQueryListByCode, storeQueryByStoreId } from '@/api/crm'
export default {
  name: 'apply-sp',
  components: {
    CombinedDialog
  },
  data () {
    return {
      basicInfo: {
        storeCode: '',
        skuList: [
          {
            isSeries: false
          }
        ]
      },
      specialPriceVo1: {
        applyType: 'APPLY_BASE',
        salesman: '',
        skuGroupId: this.$route.query.id,
        specials: [],
        storeCode: '',
        storeId: '',
        storeName: ''
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSkuGroupMsg()
  },
  methods: {
    radioChange (e) {
      for (const k of this.specialPriceVo1.specials) {
        k.price = ''
      }
      this.basicInfo.skuList.forEach(item => {
        this.specialPriceVo1.specials.forEach(v => {
          if (item.id === v.skuId) {
            if (e === 'APPLY_BASE') {
              if (item.applyPrice) v.price = item.applyPrice
            } else {
              if (item.price) v.price = item.price
            }
          }
        })
      })
    },
    // 申请
    applySpecialStore () {
      if (this.specialPriceVo1.storeId === '') {
        this.$message.error('未选择平台')
        return
      }
      let priceReg = false
      // this.specialPriceVo1.specials.forEach(item => {
      //   if (!item.price) priceReg = true
      // })
      console.log(this.specialPriceVo1.specials, 'this.specialPriceVo1.specials')
      priceReg = this.specialPriceVo1.specials.find(v => !v.price)
      if (priceReg) {
        if (this.specialPriceVo1.applyType === 'APPLY_BASE') {
          this.$message.error('申请基础P数价格不能为空')
          return
        }
        if (this.specialPriceVo1.applyType === 'APPLY_DISCOUNT') {
          this.$message.error('申请折扣不能为空')
          return
        }
      }
      let priceLock = false
      this.specialPriceVo1.specials.forEach(item => {
        if (!this.$reg.price.reg.test(item.price)) {
          priceLock = true
        }
      })
      if (priceLock) {
        this.$message.error(this.$reg.price.message)
        return
      }

      skuSpecialAdd(this.specialPriceVo1).then(res => {
        if (res.data.success) {
          this.$message.success('申请特殊价格成功')
          this.$router.go(-1)
        }
      })
    },
    // 选择平台
    handleSelect (item) {
      this.specialPriceVo1.storeCode = item.code
      this.specialPriceVo1.storeId = item.id
      this.specialPriceVo1.storeName = item.name
      storeQueryByStoreId(item.id).then(res => {
        if (res.data.success) {
          this.specialPriceVo1.salesman = res.data.data.salesman ? res.data.data.salesman.fullName : ''
          this.specialPriceVo1.userId = res.data.data.salesman ? res.data.data.salesman.id : ''
          this.$message.success('已选择平台')
        }
      })
    },
    // 取消平台
    clear () {
    },
    // 平台号模糊查询
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    // 申请基础P数价格
    inputBasePageSpecialPrice (scope) {
      this.specialPriceVo1.specials[scope.$index].price = scope.row.applyPrice
    },
    // 整体折扣输入申请折扣
    inputSpecialPrice (scope) {
      if (scope.row.isSeries) {
        scope.row.applyBasePrice = (scope.row.basePagePrice * scope.row.discount).toFixed(2)
        this.specialPriceVo1.specials[scope.$index].price = scope.row.discount
      } else {
        scope.row.applyBasePrice = (scope.row.basePagePrice * parseFloat(scope.row.price || 0)).toFixed(2)
        scope.row.applyOncePrice = (scope.row.baseStepPrice * parseFloat(scope.row.price || 0)).toFixed(2)
        this.specialPriceVo1.specials[scope.$index].price = scope.row.price || 0
      }
    },
    // 获取该sku组信息
    getSkuGroupMsg () {
      skuGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          let list = []
          list = res.data.data.skuList
          list = list.filter(item => {
            return !item.isSample
          })
          list.forEach(item => {
            item.applyPrice = ''
            item.discount = ''
            item.applyBasePrice = ''
            item.applyOncePrice = ''
            item.price = ''
            this.specialPriceVo1.specials.push({ price: '', skuId: item.id })
          })
          this.basicInfo.skuList = list
          this.$forceUpdate()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
